import { render, staticRenderFns } from "./ViewSeedingTaskDetail.vue?vue&type=template&id=684b52f2&scoped=true"
import script from "./ViewSeedingTaskDetail.vue?vue&type=script&lang=js"
export * from "./ViewSeedingTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewSeedingTaskDetail.vue?vue&type=style&index=0&id=684b52f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b52f2",
  null
  
)

export default component.exports